var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3d",
    "data-name": "3d",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 38.61,
    y1: 100.26,
    x2: 86.52,
    y2: 31.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#09ff83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21ff8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#49ff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ffa0"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "v3D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.01 28.87 64 57.75 23.11 34.15 64 10.54 94.21 27.98 103.34 22.71 64 0 8.57 32 8.57 38.31 58.56 67.17 58.56 114.32 17.7 90.73 17.7 55.9 8.57 50.63 8.57 96 64 128 69.44 124.86 69.44 67.17 110.3 43.58 110.3 90.73 80.11 108.16 80.11 118.7 119.43 96 119.43 32 114.01 28.87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3d.89e5dad0a976bc0a986742003e9c6218.svg";
export { ForwardRef as ReactComponent };